function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}");
function SvgJcb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21477 0 0 .21477 -2.2336 27.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8215 0 0 1.8215 -8.5438 -109.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m174 108.3c0 14-11.4 25.4-25.4 25.4h-138.2v-100.6c0-14 11.4-25.4 25.4-25.4h138.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 117.39,
    x2: 157.33,
    y1: 81.399,
    y2: 81.399,
    gradientTransform: "matrix(1.125 0 0 1.125 -11.976 -13.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#007940"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00873F"
    },
    offset: 0.2285
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#40A737"
    },
    offset: 0.7433
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5CB531"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m129 82.5h10.5c0.3 0 1-0.1 1.3-0.1 2-0.4 3.7-2.2 3.7-4.7 0-2.4-1.7-4.2-3.7-4.7-0.3-0.1-0.9-0.1-1.3-0.1h-10.5z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 117.38,
    x2: 157.33,
    y1: 75.171,
    y2: 75.171,
    gradientTransform: "matrix(1.125 0 0 1.125 -11.976 -13.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#007940"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00873F"
    },
    offset: 0.2285
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#40A737"
    },
    offset: 0.7433
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5CB531"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m138.3 16.2c-10 0-18.2 8.1-18.2 18.2v18.9h25.7c0.6 0 1.3 0 1.8 0.1 5.8 0.3 10.1 3.3 10.1 8.5 0 4.1-2.9 7.6-8.3 8.3v0.2c5.9 0.4 10.4 3.7 10.4 8.8 0 5.5-5 9.1-11.6 9.1h-28.2v37h26.7c10 0 18.2-8.1 18.2-18.2v-90.9z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 117.38,
    x2: 157.33,
    y1: 68.399,
    y2: 68.399,
    gradientTransform: "matrix(1.125 0 0 1.125 -11.976 -13.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#007940"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00873F"
    },
    offset: 0.2285
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#40A737"
    },
    offset: 0.7433
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5CB531"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m143.2 63.1c0-2.4-1.7-4-3.7-4.3-0.2 0-0.7-0.1-1-0.1h-9.5v8.8h9.5c0.3 0 0.9 0 1-0.1 2-0.3 3.7-1.9 3.7-4.3z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 27.959,
    x2: 68.522,
    y1: 75.171,
    y2: 75.171,
    gradientTransform: "matrix(1.125 0 0 1.125 -11.976 -13.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1F286F"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#004E94"
    },
    offset: 0.4751
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0066B1"
    },
    offset: 0.8261
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#006FBC"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m37.7 16.2c-10 0-18.2 8.1-18.2 18.2v44.9c5.1 2.5 10.4 4.1 15.7 4.1 6.3 0 9.7-3.8 9.7-9v-21.2h15.6v21.1c0 8.2-5.1 14.9-22.4 14.9-10.5 0-18.7-2.3-18.7-2.3v38.3h26.7c10 0 18.2-8.1 18.2-18.2v-90.8z",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    x1: 72.46,
    x2: 111.86,
    y1: 75.171,
    y2: 75.171,
    gradientTransform: "matrix(1.125 0 0 1.125 -11.976 -13.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6C2C2F"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#882730"
    },
    offset: 0.1735
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#BE1833"
    },
    offset: 0.5731
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#DC0436"
    },
    offset: 0.8585
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#E60039"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m88 16.2c-10 0-18.2 8.1-18.2 18.2v23.8c4.6-3.9 12.6-6.4 25.5-5.8 6.9 0.3 14.3 2.2 14.3 2.2v7.7c-3.7-1.9-8.1-3.6-13.8-4-9.8-0.7-15.7 4.1-15.7 12.5 0 8.5 5.9 13.3 15.7 12.5 5.7-0.4 10.1-2.2 13.8-4v7.7s-7.3 1.9-14.3 2.2c-12.9 0.6-20.9-1.9-25.5-5.8v42h26.7c10 0 18.2-8.1 18.2-18.2v-91z",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.285f606c.svg";
export { ForwardRef as ReactComponent };